import { JSONSerializable } from '../../../util/json';
import { Coins } from '../../Coins';
import { AccAddress } from '../../strings';

export class MsgMultiSend extends JSONSerializable<MsgMultiSend.Data> {
  constructor(
    public inputs: MsgMultiSend.Input[],
    public outputs: MsgMultiSend.Output[]
  ) {
    super();
  }

  public static fromData(data: MsgMultiSend.Data): MsgMultiSend {
    const {
      value: { inputs, outputs },
    } = data;
    return new MsgMultiSend(
      inputs.map(i => MsgMultiSend.Input.fromData(i)),
      outputs.map(o => MsgMultiSend.Output.fromData(o))
    );
  }

  public toData(): MsgMultiSend.Data {
    const { inputs, outputs } = this;
    return {
      type: 'bank/MsgMultiSend',
      value: {
        inputs: inputs.map(i => i.toData()),
        outputs: outputs.map(o => o.toData()),
      },
    };
  }
}

export namespace MsgMultiSend {
  export interface Data {
    readonly type: 'bank/MsgMultiSend';
    value: {
      inputs: IO.Data[];
      outputs: IO.Data[];
    };
  }

  export class IO extends JSONSerializable<IO.Data> {
    public coins: Coins;
    constructor(public address: AccAddress, coinsInput: Coins.Input) {
      super();
      this.coins = new Coins(coinsInput);
    }

    public toData(): IO.Data {
      const { address, coins } = this;
      return {
        address,
        coins: coins.toData(),
      };
    }

    public static fromData(data: IO.Data): IO {
      const { address, coins } = data;
      return new IO(address, Coins.fromData(coins));
    }
  }

  export const Input = IO;
  export const Output = IO;
  export type Input = IO;
  export type Output = IO;

  export namespace IO {
    export interface Data {
      address: AccAddress;
      coins: Coins.Data;
    }
  }
}
